import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/dist/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails";
import Video from "yet-another-react-lightbox/dist/plugins/video";
import "yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css";

// Example breakpoints array (adjust according to your requirements)
const breakpoints = [480, 768, 1024];

// Gallery component
const Gallery = ({ images, onClick }) => {
  const [isShow, setIsShow] = useState(true);
  useEffect(() => {
    setIsShow(true);
  }, [images]);
  // Toggle show/hide
  const showHide = () => {
    onClick();
    setIsShow((prev) => !prev)
  };
  return (
    <>
      {images?.length > 0 && (
        <Lightbox
          open={isShow}
          close={showHide}
          toolbar={{
            buttons: [
              "close",
            ],
          }}
          styles={{ root: { direction: "ltr" } }}
          slides={images?.map(({ medium, type, thumb }) =>
            type
              ? type === "image"
                ? {
                    src: `https://www.kadro.co${medium}`,
                    srcSet: breakpoints.map((breakpoint) => ({
                      src: `https://www.kadro.co${medium}`,
                      width: breakpoint,
                    })),
                  }
                : {
                    type: "video",
                    poster: `https://www.kadro.co${thumb}`,
                    sources: [
                      {
                        src: `https://www.kadro.co${medium}`,
                        type: "video/mp4",
                      },
                    ],
                    width: '90%',
                    height: "auto"
                  }
              : {
                  src: `https://www.kadro.co${medium}`,
                  srcSet: breakpoints.map((breakpoint) => ({
                    src: `https://www.kadro.co${medium}`,
                    width: breakpoint,
                  })),
                }
          )}
          plugins={[Fullscreen, Slideshow, Thumbnails, Video]}
          carousel={{ preload: 10, finite: true }}
          thumbnails={{
            border: 0,
          }}
        />
      )}
    </>
  );
};

export default Gallery;
